interface CustomIconIvrChannelProps extends React.SVGProps<SVGSVGElement> {}

export function CustomIconIvrChannel({ width, height }: CustomIconIvrChannelProps) {
  return (
    <svg width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="#1C1C28"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4.42 9.978c1.9-1.33 3.122-1.657 4.287.379 1.323 2.31 1.551 4.218.135 5.704-.299.313 1.215 3.39 4.54 6.433.803.461.896.01 2.218-.589 1.983-.898 4.748 2.265 4.685 3.462-.035.688-1.213 2.778-2.785 3.243-3.897 1.152-10.154-5.64-12.926-11.336-.896-1.84-1.778-3.99-1.648-5.148.086-.772.585-1.488 1.495-2.148Z"
        clipRule="evenodd"
      />
      <path
        stroke="#1C1C28"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4.396 10.211s1.122 2.805 2.244 3.926M28.06 16.538l-5.134 2.933a.62.62 0 0 1-.926-.538v-5.866a.62.62 0 0 1 .926-.538l5.133 2.934a.62.62 0 0 1 0 1.075ZM14.492 4.599v4.906c0 .825.67 1.495 1.495 1.495h2.208c.825 0 1.495-.67 1.495-1.495V4.599a2.6 2.6 0 0 0-5.198 0Z"
      />
      <path
        fill="#1C1C28"
        d="M18 11.5a1 1 0 1 0-2 0h2ZM17 17v1h1v-1h-1Zm-2-1a1 1 0 1 0 0 2v-2Zm4 2a1 1 0 1 0 0-2v2Zm-2-6.5h-1V17h2v-5.5h-1Zm0 5.5v-1h-2v2h2v-1Zm-2 0v1h4v-2h-4v1Z"
      />
    </svg>
  );
}
